'use strict';
export default function routes($stateProvider) {
    'ngInject';
    $stateProvider
        .state('education', {
        url: '/education',
        template: require('./template.html'),
        controller: 'EducationController',
        controllerAs: 'vm',
        abstract: true
    })
        .state('education.clinicalResources', {
        url: '/clinical-resources',
        template: require('./clinical-resources/template.html'),
        controller: 'ClinicalResourcesController',
        controllerAs: 'crvm'
    })
        .state('education.practiceManagement', {
        url: '/practice-management',
        template: require('./practice-management/template.html'),
        controller: 'PracticeManagementController',
        controllerAs: 'prvm'
    })
        .state('education.clinicalResources.resourcesByHealthCondition', {
        url: '/resources-by-health-condition',
        template: require('./clinical-resources/resources-by-health-condition/template.html'),
        controller: 'ResourcesByHealthConditionController',
        controllerAs: 'rbhvm'
    })
        .state('education.clinicalResources.resourcesBySupplements', {
        url: '/resources-by-supplements',
        template: require('./clinical-resources/resources-by-supplements/template.html'),
        controller: 'ResourcesBySupplementsController',
        controllerAs: 'rbsvm'
    })
        .state('education.clinicalResources.askOurExperts', {
        url: '/ask-our-experts',
        template: require('./clinical-resources/ask-our-experts/template.html'),
        params: { productName: null, itemCode: null },
        controller: 'AskOurExpertsController',
        controllerAs: 'aoevm'
    })
        .state('education.clinicalResources.clinicalPracticeTools', {
        url: '/clinical_practice_tools',
        template: require('./clinical-resources/clinical_practice_tools/template.html'),
        controller: 'ClinicalPracticeToolsController',
        controllerAs: 'cptvm'
    })
        .state('education.clinicalResources.drugDepletionsInteractions', {
        url: '/drug-depletions-interactions',
        template: '<drug-depletions-interactions></drug-depletions-interactions>'
    })
        .state('education.practiceManagement.buildingAnexpertDispensary', {
        url: '/building-an-expert-dispensary',
        template: require('./practice-management/building-an-expert-dispensary/template.html'),
        controller: 'BuildingAnExpertDispensaryController',
        controllerAs: 'baedvm'
    })
        .state('education.practiceManagement.optimizingClinicalOperations', {
        url: '/optimizing-clinical-operations',
        template: require('./practice-management/optimizing-clinical-operations/template.html'),
        controller: 'OptimizingClinicalOperationsController',
        controllerAs: 'ocovm'
    })
        .state('education.practiceManagement.masteringSalesAndMarketing', {
        url: '/mastering-sales-and-marketing',
        template: require('./practice-management/mastering-sales-and-marketing/template.html'),
        controller: 'MasteringSalesAndMarketingController',
        controllerAs: 'msamvm'
    })
        .state('education.practiceManagement.leveragingTechnology', {
        url: '/leveraging-technology',
        template: require('./practice-management/leveraging-technology/template.html'),
        controller: 'LeveragingTechnologyController',
        controllerAs: 'ltvm'
    })
        .state('education.practiceManagement.enhancingPatientCompliance', {
        url: '/enhancing-patient-compliance',
        template: require('./practice-management/enhancing-patient-compliance/template.html'),
        controller: 'EnhancingPatientComplianceController',
        controllerAs: 'epccvm'
    })
        .state('education.clinicalResources.clinicalUpdates', {
        url: '/clinical-updates',
        template: require('./clinical-resources/clinical-updates/template.html'),
        controller: 'ClinicalUpdatesController',
        controllerAs: 'cuvm'
    })
        .state('education.clinicalUpdatesBlog', {
        url: 'http://blog.emersonecologics.com/',
    })
        .state('education.clinicalUpdatesAuthors', {
        url: '/clinical-updates/authors',
        template: require('./clinical-resources/clinical-updates/authors/template.html'),
        controller: 'ClinicalUpdatesAuthorsController',
        controllerAs: 'cuavm'
    })
        .state('education.clinicalUpdatesElements', {
        url: '/clinical-updates/elements',
        template: require('./clinical-resources/clinical-updates/elements/template.html'),
        controller: 'ClinicalUpdatesElementsController',
        controllerAs: 'cuevm'
    })
        .state('education.meetOurTeam', {
        url: '/ask-our-experts/meet-our-team',
        template: require('./clinical-resources/ask-our-experts/meet-our-team/template.html'),
        controller: 'MeetOurTeamController',
        controllerAs: 'mtvm'
    })
        .state('education.clinicalResources.educationPartners', {
        url: '/education-partners',
        template: require('./clinical-resources/education-partners/template.html'),
        controller: 'EducationPartnerController',
        controllerAs: 'epvm'
    })
        .state('education.partnerKalish', {
        url: '/patner-DrKalish',
        template: require('./clinical-resources/education-partners/partners/partner-kalish/template.html'),
        controller: 'PartnerController',
        controllerAs: 'pvm'
    })
        .state('education.tapItegrativePage', {
        url: '/education-partners/tap-integrative-page',
        template: require('./clinical-resources/education-partners/tap-integrative-page/template.html'),
        controller: 'TapIntegrativePageController',
        controllerAs: 'tapvm'
    });
}
//# sourceMappingURL=education.routes.js.map